function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2682820---forecast-hail-rain-snow-stones-storm-weather",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#C4C4C4",
  fillRule: "nonzero",
  cx: 124.5,
  cy: 63.8514002,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,98.3514002 L133,98.3514002",
  id: "Path",
  stroke: "#0D98FF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,113.3514 L108,113.3514",
  id: "Path",
  stroke: "#0D98FF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,16.3514002 L49,81.3514002 C43.3174639,74.5799058 36.1329484,69.1840349 28,65.579524",
  id: "Path",
  stroke: "#0BAEFF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83,26.3514002 L83,81.3514002 C83,81.3514002 91.8092933,65.6477466 109,65.59813",
  id: "Path",
  stroke: "#0BAEFF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#C4C4C4",
  fillRule: "nonzero",
  cx: 9.5,
  cy: 60.8514002,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M66,1.35140018 L66,33.3514002",
  id: "Path",
  stroke: "#0BAEFF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66,51.3514002 L66,73.3514002",
  id: "Path",
  stroke: "#0BAEFF",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function SvgRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "142px",
    height: "123px",
    viewBox: "0 0 142 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2682820 - forecast hail rain snow stones storm weather") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.8e10718e.svg";
export { ForwardRef as ReactComponent };